import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import api from '../config.json';
import axios from '../httpServices/httpService';
import _ from 'lodash'
import XLSX from 'xlsx';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loading from './LoadingComponent';


const Excelimport = ({Data,API,handelUpdate}) => {


  const [MoldMasterList, setMoldMasterList] = useState([]);
  const [sortColumn, setSortColumn] = useState({ path: 'MoldId', order: 'asc' });
  const [querySuccess, setQuerySuccess] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [errors, setErrors] = useState(null);
  const [errorModal, setErrorModal] = useState(false);
  const [rowNumber, setRowNumber] = useState(0);
  const [errorFlag, setErrorFlag] = useState(false);
  const [objKey, setObjKey] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [ImportDone, setImportDone] = useState(false);

  // useEffect(() => {
  // if(ImportDone){
  //   handelUpdate();
  // }
  // }, [ImportDone])
  
  
  const handleUploadGuagesDoc = () => {
    let link = document.createElement('input');
    link.setAttribute('type', 'file');
    link.setAttribute('name', 'EquipmentList');
    let self = this;

    document.body.appendChild(link);
    link.click();

    link.onchange = async function (e) {
      e.preventDefault();
      let fr = new FileReader();
      fr.readAsBinaryString(e.currentTarget.files[0]);
      fr.onloadend = async function (e) {
        const wb = XLSX.read(e.target.result, { type: 'binary', cellDates: true });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        let dataArray = [];
        let keyArr = data[0];
        keyArr = keyArr.map(x => x && x.trim())
        let arr = data.slice(1, data.length);
        arr.forEach((oneArr) => {
          let obj = {};
          oneArr.forEach((value, i) => {
            if (keyArr[i] == "PartName"||keyArr[i] == "PartNumber") {
              value = value.split(',');
              value = value.filter(x => x);
              value = value.map(x => x);
              obj[[keyArr[i]]] = value;
            } else {
              obj[[keyArr[i]]] = value.toString();
            }
          });
          dataArray.push(obj);
        });

        setExcelData(dataArray);
        console.log(dataArray, "imported excel data")
        // return
        await sendDataToServer(dataArray, dataArray, 0);
      };
    };
    document.body.removeChild(link);
  };
  const sendDataToServer = async (DataArray, originalDataArray, idx) => {
    setQuerySuccess(true);
    for (let index = idx; index < DataArray.length; index += 1) {
      try {
        // let error = valid.validate(DataArray[index], this.schema);
        let error = null

        if (error !== null) {
          let row = index + 1;
          setErrors(error);
          setQuerySuccess(false);
          setErrorModal(true);
          setRowNumber(row);
          break;
        } else {
          const ExcelData = DataArray[index];
          let res = await axios.post(api.api + API,  ExcelData );
          Data && Data()
          if (res.status == 200) {
            toast.success(`🦄 Data Saved Successfully`
              //  DataArray[index].EquipmentID
              , {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
      handelUpdate()

          }
        }
      } catch (err) {
        if (err.response.data.code === 500) {
          console.log(err.response.data, "eivbibv")
          let message = err.response.data.message

          AbortAndResumeProcess(message, DataArray, originalDataArray, index);
        }
        if (err.response.data.code === 1100) {
          let message = err.response.data.message;

          AbortAndResumeProcess(message, DataArray, originalDataArray, index);
        } else {
          let message = (err.response.data.message);

          console.log(err.response.data, "vsivbifv")
          //   let message = JSON.parse(err);

          setQuerySuccess(false);

          setObjKey(message.key);
          setErrorMessage(message.message);
          setErrorFlag(true);
          // if (message.key === 'DeviceID') {
          //   swal(`${message.message}  , \n  Please contact leafnet admin customer support !`, { dangerMode: true });
          // } else {
          //   insertIfNotExistDataTypeAndResumeProcess(message.message, message.key.toLowerCase(), message.key, DataArray[index][message.key], originalDataArray, index);
          // }
        }
        break;
      }
    }
    setQuerySuccess(false);
  };
  const AbortAndResumeProcess = (message, dataArray, originalArr, index) => {
    let row = index + 1;
    swal({
      title: "Are you sure?",
      text: message  + ' Do you want skip it ',
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        index = index + 1;
        sendDataToServer(dataArray, originalArr, index)
      } else {
        // this.setState({querySuccess:false,arrayProcessIndex:index})
        swal('Process  Abort', { dangerMode: true });

        // swal("Your imaginary file is safe!");
      }
    });
  }
  return (
    <>
    {querySuccess && <Loading/>}
    <ToastContainer/>
     <button type="button" className="btn-sm btn-secondary ml-2 mt-2 text-white"
      onClick={() => handleUploadGuagesDoc()}
    ><FontAwesomeIcon icon={faFileImport} /> Import Excel</button>
    </>
   
  )
}

export default Excelimport